import ExpandedList from "components/Layout/components/ObjectPanel/ExpandedList";
import {useGetFavAssetsQuery} from "hooks";
import React from "react";

function Favorites({currentType, listType}) {
  const {data, fetchNextPage, hasNextPage} = useGetFavAssetsQuery(currentType);

  return (
    <>{!!data?.pages[0] && <ExpandedList listType={listType} data={data} fetchNextPage={fetchNextPage} hasNextPage={hasNextPage} />}</>
  );
}

export default Favorites;
